import type { AccountBadge } from '@olimhub/shared'
import { BadgePill } from './BadgePill'

interface BadgeListProps {
  badges: AccountBadge[]
}

const MAX_SHOWN = 5

export function BadgeList({ badges }: BadgeListProps) {
  const visible = badges.filter((ab) => ab.isVisible && ab.badge.showOnProfile)
  if (visible.length === 0) return null

  const shown = visible.slice(0, MAX_SHOWN)
  const rest = visible.length - MAX_SHOWN

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {shown.map((ab) => (
        <BadgePill key={ab.id} accountBadge={ab} size="md" />
      ))}
      {rest > 0 && (
        <span
          style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--fs-xs)',
            fontWeight: 500,
            color: 'var(--text-muted)',
          }}
        >
          +{rest} more
        </span>
      )}
    </div>
  )
}
